require("es6-promise").polyfill();
require("isomorphic-fetch");

export default class RecreationGovClient {
  getSites() {
    //return this.getSitesLocally();
    return fetch(this.baseUrl + "sites")
      .then(function(response) {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  validateAndGetPrice(priceObject) {
    return fetch(
      //"https://localhost:5001/api/r1s/" + "passtypes/price",
      this.baseUrl + "passtypes/price",
      {
        method: "post",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(priceObject)
      }
    )
      .then(function(response) {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  getOrderStatus(requestData) {
    return fetch(this.baseUrl + "indirect/validate", {
      method: "post",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(requestData)
    })
      .then(function(response) {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  // eslint-disable-next-line
  getParkPassTypes(siteId) {    
    //return this.getParkPassTypesLocally(siteId);
    return fetch(this.baseUrl + "passtypes/" + siteId)
      .then(function(response) {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  createPendingOrder(order) {
    return fetch(this.baseUrl + "indirect", {
      method: "post",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(order)
    })
      .then(function(response) {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  preparePayment(order) {
    return fetch(this.baseUrl + "preparepayment", {
      //return fetch("https://localhost:5001/api/r1s/preparepayment", {
      method: "post",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(order)
    })
      .then(function(response) {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  getSitesLocally() {
    return fetch("/sampledata/facilities.json")
      .then(response => {
        return response.json();
      })
      .catch(error => {
        throw error;
      });
  }

  getParkPassTypesLocally(siteId) {
    return fetch("/sampledata/" + siteId + "_passtypes.json")
      .then(response => {
        let resp = response.json();
        return resp;
      })
      .catch(error => {
        throw error;
      });
  }

  baseUrl = process.env.VUE_APP_API_URL;
}
